// extracted by mini-css-extract-plugin
module.exports = {"c_purple_light":"#6E4AFF"};